import { equals } from 'ramda';
import type { Editor, NodeEntry } from 'slate';
import { Transforms } from 'slate';

import type { DynamicBlockElement } from '../../internal';
import { AlineTransforms } from '../../internal';

export function normalizeDynamicBlock(
  editor: Editor,
  dynamicBlockEntry: NodeEntry<DynamicBlockElement>
): void {
  const [dynamicBlock, dynamicBlockPath] = dynamicBlockEntry;
  // If the DC is empty, remove it from the tree and exit.
  if (!dynamicBlock.children.length)
    return Transforms.removeNodes(editor, {
      at: dynamicBlockPath,
      voids: true,
    });

  ensureSyncedTriggerContent(editor, dynamicBlockEntry);
}

// === Helper functions ===

/**
 * When editing a dynamic block, we want to make sure that the content of the dynamic block is always
 * in sync with the corresponding trigger content.
 */
export function ensureSyncedTriggerContent(
  editor: Editor,
  dynamicBlockEntry: NodeEntry<DynamicBlockElement>
): void {
  const [dynamicBlock, dynamicBlockPath] = dynamicBlockEntry;
  const { triggerIndex, triggers = [] } = dynamicBlock;
  // Nothing to do if there's no triggerIndex selected.
  if (typeof triggerIndex !== 'number') return;

  const trigger = triggers[triggerIndex];
  if (!trigger) return;

  // If already equivalent, noop.
  const isTriggerAlreadyEqual = equals(trigger.contentJSON, dynamicBlock.children);
  if (isTriggerAlreadyEqual) return;

  const newTriggers = triggers.map((trigger, index) =>
    index === triggerIndex ? { ...trigger, contentJSON: dynamicBlock.children } : trigger
  );
  AlineTransforms.setDynamicContentProps(editor, {
    at: dynamicBlockPath,
    props: { triggers: newTriggers },
  });
}
